function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function EventDetails() {
  return (
    <section className="panel panel--parchment" id="welcome">
      <div className="parchment-frame">
        <div className="welcome">
          <img className="welcome__logo" src="/logo.png" alt="Valéo" draggable={false} />

          <h1 className="welcome__headline">
            <span className="welcome__line welcome__line--lead">Rooftop session in Zürich</span>
            <span className="welcome__line">Built around music, carefully selected people and atmosphere.</span>
          </h1>

          <img className="welcome__shells" src="/conchiglie.png" alt="" aria-hidden="true" draggable={false} />

          <p className="welcome__meta">
            Friday, May 29 — 18:00–22:30
            <br />
            Bahnhofquai 11, 8001 Zürich
          </p>

          <button
            type="button"
            className="cta-link"
            onClick={() => scrollToId('reserve')}
          >
            scroll down for more
          </button>
        </div>
      </div>
    </section>
  );
}
